import Common from '../../../../Common';

interface Body {
	group_id: id
}

const Group = class extends Common {
	async browse(companyId: id, departmentId: id) {
		return this.get(`/company/${companyId}/department/${departmentId}/acl/group`)
	}

	async create(companyId: id, departmentId: id, data: Body) {
		return this.post(`/company/${companyId}/department/${departmentId}/acl/group`, data)
	}

	async delete(companyId: id, departmentId: id, groupId: id) {
		return this.doDelete(`/company/${companyId}/department/${departmentId}/acl/group/${groupId}`)
	}
}

export default Group
